import { Box, Button, Stack, TextField } from '@mui/material';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../store/actions/GlobalActions';
import { notEmpty, validPhone } from '../../util/Validation';
import { useTranslation } from 'react-i18next';

export function EnterPhone() {
  const { t } = useTranslation();
  const selectedPhone = useSelector((state) => state.GlobalReducer.registrationInfo.phone);
  const [phone, setPhone] = useState(selectedPhone);

  const dispatch = useDispatch();
  const handleNext = () => {
    dispatch({ type: actions.ENTER_PHONE, payload: phone });
    dispatch({ type: actions.NEXT_REGISTRATION_STEP });
  };

  const handleBack = () => {
    dispatch({ type: actions.PREVIOUS_REGISTRATION_STEP });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 5 }}>
      <TextField type="" error={!validPhone(phone)} value={phone} onChange={(event) => setPhone(event.target.value)} label={t('enter_phone')}></TextField>
      <Stack direction="row" sx={{ marginTop: 5 }}>
        <Button sx={{ width: '50%' }} onClick={handleBack}>
          {t('back')}
        </Button>
        <Button disabled={!notEmpty(phone, validPhone)} sx={{ width: '50%' }} variant="contained" color="primary" onClick={handleNext}>
          {t('continue')}
        </Button>
      </Stack>
    </Box>
  );
}
